import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import IconButton from 'material-ui/IconButton';
// import DeleteIcon from 'material-ui/svg-icons/action/delete';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import IconDelete from 'material-ui/svg-icons/action/delete';


import Moment from 'react-moment';
import 'moment-timezone';
import 'moment/locale/es';

import FileIcon from './FileIcon';


const styleCanvas = {
    // border :'3px solid grey',
    maxWidth: 100,
    maxHeight: 100
};

let mainStyle = {
    opacity: '1',
};

let loadingStyle = {
    opacity: '0.25',
};

class Upload extends Component {

    state = {
        loading: false
    };

    static propTypes = {
        id: PropTypes.number,
        item: PropTypes.object,
        onDelete: PropTypes.func
    }

    onDeleteHandler = (e) => {
        if (typeof this.props.onDelete === 'function') {
            this.setState({ loading: true })
            this.props.onDelete(this);
        }
    }


    render() {

        const { item } = this.props;
        const { loading } = this.state;

        return (
            <div className="attach">

                <div className="small">
                    <FileIcon item={item} />
                </div>
                <span className="name">{item.name}</span>

                <IconButton
                    tooltip="Eliminar"
                    tooltipPosition="bottom-center"
                    className="btn-delete"
                    onClick={this.onDeleteHandler}
                >
                    <IconDelete />
                </IconButton>

            </div>
        );

    };

}

export default Upload;


// WEBPACK FOOTER //
// ./src/modules/notes/Upload.js